import React, { useRef } from "react";
import { createPortal } from "react-dom";
// Import the FOLDER component explicitly — "../FilterMenu" would resolve
// to the legacy FilterMenu.js file (files beat folders), which carries no
// CSS and left the dropdown unstyled.
import FilterMenu from "../FilterMenu/FilterMenu";
import "./styles/sort.css";

/**
 * FilterButton
 * The Excel-style Sort + Filter dropdown shown on a column.  The button
 * sits on the first data row's cell; the POPUP is rendered through a portal
 * to <body>, anchored to the button's on-screen position.  Portalling it
 * out of the grid cell fixes a whole class of bugs: the popup is no longer
 * clipped by / stacked under frozen panes, no longer scrolls away with the
 * cell, and no longer breaks when the cell re-renders or is virtualized out.
 */
function FilterButton({
  colIndex, isFiltered, isMenuOpen,
  rows, currentFilter, sortState,
  onToggle, onApply, onClose,
  onSortAsc, onSortDesc, onClearSort, onCustomSort,
}) {
  const btnRef = useRef(null);
  // sortDir is still passed to the popup (to highlight its A–Z / Z–A toggle),
  // but the on-grid sort ARROW now lives on the column-letter header
  // (ColumnHeader) so it shows on every sheet — not just filter columns.
  const sortDir = sortState ? sortState.dir : null;
  const title = isFiltered ? "Filtered · Sort & Filter" : "Sort & Filter";

  return (
    <>
      <span
        ref={btnRef}
        className={`filter-excel-btn ${isFiltered ? "filtered" : ""}`}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => onToggle(colIndex, e)}
        title={title}
      >
        <span className="material-icons" style={{ fontSize: isFiltered ? "14px" : "16px" }}>
          {isFiltered ? "filter_alt" : "arrow_drop_down"}
        </span>
      </span>
      {isMenuOpen && createPortal(
        <FilterMenu
          anchorEl={btnRef.current}
          colIndex={colIndex}
          rows={rows}
          currentFilter={currentFilter}
          onApply={(sel) => onApply(colIndex, sel)}
          onClose={onClose}
          sortDir={sortDir}
          onSortAsc={onSortAsc}
          onSortDesc={onSortDesc}
          onClearSort={onClearSort}
          onCustomSort={onCustomSort}
        />,
        document.body,
      )}
    </>
  );
}

export default React.memo(FilterButton);
